<template>
  <div>
    <vx-card>
      <div>
        <div class="flex justify-end">
          <vs-button v-if="canDeleteField && !!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">{{ $t("삭제") }}</vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">{{ $t("목록") }}</vs-button>
          <vs-button class="ml-4" color="secondary" @click="onClickSave">{{ $t("저장") }}</vs-button>
        </div>
        <p class="title mt-5 mb-5">{{ $t("회사 정보") }}</p>
        <div class="writeGridContainer">
          <div>
            <div>{{ $t("회사명(필수)") }}</div>
            <ml-input v-model="form.field_name" />
          </div>
          <div>
            <div>{{ $t("업종") }}</div>
            <ml-input v-model="업종" />
          </div>
          <div>
            <div>{{ $t("규모") }}</div>
            <ml-input v-model="규모" />
          </div>
          <div>
            <div>{{ $t("담당자") }}</div>
            <ml-input v-model="form.director_name" />
          </div>
          <div>
            <div>{{ $t("주소") }}</div>
            <ml-input v-model="form.address" />
          </div>
          <div>
            <div>{{ $t("사업장 연락처") }}</div>
            <ml-input v-model="form.phone" :placeholder="$t('예) 055-123-4567')" />
          </div>
        </div>
      </div>

      <!-- 담당 회사 및 수급업체 현황 -->
      <company-add-module
        title="부서 및 담당자 정보"
        :tableColumns="[
          // { head: '구분', key: 'com_type' },
          { head: '부서명', key: 'com_name' },
          // { head: '대표자', key: 'com_ceo' },
          { head: '담당자', key: 'director' },
          { head: '연락처', key: 'phone' },
        ]"
        :is-simple="true"
        detailTitle="회사 세부 정보"
        detailLabelComName="회사명"
        add-button-name="등록"
        popup-title="부서 및 담당자 정보"
        v-model="companyList"
        @remove="removeCompany"
      />

      <!-- 참여 인원 정보 -->
      <!--      <company-user-auth-module-->
      <!--        popupTitle="회사 불러오기"-->
      <!--        permissionHead="권한설정"-->
      <!--        :colData="[-->
      <!--            { head: '구분', key: 'company_id' },-->
      <!--            { head: '사용자명', key: 'name' },-->
      <!--            { head: '연락처', key: 'phone' },-->
      <!--          ]"-->
      <!--        :users="userList"-->
      <!--        v-model="joinUsers"-->
      <!--        class="mt-28px"-->
      <!--      />-->

      <!--      <div class="flex flex-col md:flex-row gap-x-4 gap-y-6 mt-28px">-->
      <!--        <div class="flex-1">-->
      <!--          <p class="title-n">{{ $t('현장조감도') }}</p>-->
      <!--          <file-uploader type="only-image" class="upload-img" v-model="form.field_view" />-->
      <!--        </div>-->
      <!--        <div class="flex-1">-->
      <!--          <p class="title-n">{{ $t('현장약도') }}</p>-->
      <!--          <file-uploader type="only-image" class="upload-img" v-model="form.field_map" />-->
      <!--        </div>-->
      <!--        <div class="flex-1">-->
      <!--          <p class="title-n">{{ $t('현장사진') }}</p>-->
      <!--          <file-uploader type="only-image" class="upload-img" v-model="form.field_photo" />-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <file-upload-module v-model="fileList" class="mt-28px" />-->
    </vx-card>
  </div>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import DateSelector from "@/components/selector/DateSelector";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    DateSelector,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileInput,
    FileUploadModule,
  },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        deposit_amount: "", // 계약금액
        director_name: "", // 담당자
        address: "", //주소
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 완료
        phone: "", // 대표번호
        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진

        meta: "", // 부가 정보
      },
      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],

      업종: "",
      규모: "",
    };
  },
  computed: {
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 사업장을 삭제할 수 있는지. 서버(DeleteFieldController)와 같은 기준이다.
     * - 시스템 관리자는 항상 가능
     * - 프로젝트에 "사업장 편집은 매니저 전용"이 켜져 있으면 프로젝트 관리자만, 꺼져 있으면 프로젝트 참여자 모두 가능
     */
    canDeleteField() {
      if (this.isAdmin) return true;

      const memberInfo = this.$store.state.member.memberInfo;
      const project = memberInfo && (memberInfo.projects || []).find((p) => `${p.id}` === `${this.projectId}`);
      if (!project) return false;

      const projectInfo = this.$store.state.project.projectInfo || {};
      if (projectInfo.field_edit_by_manager_only) {
        return !!(project.pivot && project.pivot.is_manager);
      }
      return true;
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    tabName() {
      return "사업장";
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  created() {
    this.initBreadcrumb();
  },
  mounted() {
    if (this.fieldId) {
      this.loadField();
    }
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업장 현황" }, { title: "사업장", active: true }]);
    },
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;
      this.joinUsers = info.users;
      this.form = { ...info };

      const meta = JSON.parse(info.meta);
      this.업종 = meta.업종;
      this.규모 = meta.규모;

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    onClickTab(tabIndex) {
      const type = this.$route.query.type;
      if (tabIndex === 0) {
        this.$router.push({ name: "field-workplace-list", query: { type } });
      } else if (tabIndex === 1) {
        const proj_id = this.$route.params.proj_id;
        if (!!type) this.$router.push({ name: "field-info-type", params: { proj_id, type } });
        else this.$router.push({ name: "field-workplace-info" });
      }
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },
    /**
     * 저장 전에 입력값을 확인한다. 문제가 있으면 안내 문구를, 없으면 빈 문자열을 반환한다.
     */
    validate() {
      if (!`${this.form.field_name || ""}`.trim()) return this.$t("회사명을 입력해 주세요.");

      const phone = `${this.form.phone || ""}`.trim();
      if (phone && !/^[0-9+()\-\s]+$/.test(phone)) {
        return this.$t("사업장 연락처는 숫자와 하이픈(-)만 입력할 수 있습니다.");
      }
      return "";
    },
    onClickSave() {
      const invalidMessage = this.validate();
      if (invalidMessage) {
        UiUtil.alertDialog(invalidMessage);
        return;
      }

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      this.form.meta = JSON.stringify({ 업종: this.업종, 규모: this.규모 });

      this.$emit("save", this.form);
    },
    onClickDelete() {
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
